import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('channel-page-content')
export class ChanngePageContent extends LitElement {
  createRenderRoot() { return this }

  render() {
    return html`
      <div class="bg-base-100 min-h-screen flex flex-col">
        <!-- Header -->
        <auth-provider>
          <app-header></app-header>

          <!-- Main Content Area -->
          <channel-list></channel-list>
        </auth-provider>
      </div>

      <auth-modal></auth-modal>
    `;
  }
}

